import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api";

export default function ViewCaseStudyPractice() {
  const { id } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/admin/case-study-practice/${id}/view`)
      .then(res => setData(res.data))
      .catch(() => alert("Failed to load practice set"))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <p>⏳ Loading...</p>;
  if (!data) return null;

  return (
    <div style={{ padding: 24 }}>
      <h2>📘 {data.title}</h2>
      <p><b>Duration:</b> {data.duration_minutes} minutes</p>

      <hr />

      {data.case_studies.map((cs, idx) => (
        <div key={cs.id} style={card}>
          <h3>{idx + 1}. {cs.title}</h3>
          <p style={{ whiteSpace: "pre-wrap" }}>{cs.description}</p>

          {cs.questions.map((q, i) => (
            <div key={q.id} style={questionBox}>
              <p><b>Q{i + 1}.</b> {q.text}</p>
              <ul>
                <li>A. {q.option_a}</li>
                <li>B. {q.option_b}</li>
                <li>C. {q.option_c}</li>
                <li>D. {q.option_d}</li>
              </ul>
              <p style={{ color: "green" }}>
                ✔ Correct Answer: {q.correct}
              </p>
            </div>
          ))}
        </div>
      ))}

      <button onClick={() => nav(-1)}>⬅ Back</button>
    </div>
  );
}

const card = {
  background: "#fff",
  padding: 16,
  marginBottom: 20,
  borderRadius: 12
};

const questionBox = {
  padding: 12,
  background: "#f8fafc",
  borderRadius: 8,
  marginTop: 10
};
